import List from '@eduzz/houston-ui/List';
import { CircularProgress, FormControlLabel, Grid, MenuItem, Switch, TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { constants } from 'helpers/constants';
import { functions } from 'helpers/functions';
import QueryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import BaseAction from 'scenes/Producer/Connect/components/BaseAction';
import { getActionFields, listConnectOptions, listTriggers, updateAction } from 'store/Orbita/Connect/actions';
import Truncate from 'v2/components/Shared/TruncateText';
import { run } from 'validations/ruleRunner';

import styles from '../../styles';
import Validations from './validations';

//import ProductSelectTable from './ProductSelectTable';
class EditAction extends BaseAction {
  state = {
    activeStep: 0,
    skipped: new Set(),
    canNext: false,
    //validations
    showErrors: false,
    isSaving: false,
    validationErrors: [] as any,
    optionsParametersList: {},
  };

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleChange = (field: any, value: any) => {
    const action = this.props.currentAction;
    let newAction = functions.cloneDeep(action);

    let { options } = this.props;
    if (field === 'option_id') {
      const selectedOption = options && Array.isArray(options) && options.find((item: any) => item.id === value);
      let fields = {};

      selectedOption &&
        selectedOption.parameters &&
        Array.isArray(selectedOption.parameters.campos) &&
        selectedOption.parameters.campos.map((item: any) => (fields[item.nome] = newAction.options_parameters[item.nome]));

      newAction.fields = fields;
      newAction.options_parameters = fields;
    }

    newAction[field] = value;
    this.props.dispatch({ type: 'CHANGE_CURRENT_ACTION', action: functions.cloneDeep(newAction) });
  };

  handleChangeField = (field: any, value: any) => {
    const currentAction = this.props.currentAction;
    let newAction = functions.cloneDeep(currentAction);

    newAction.fields = newAction.fields || {};
    if (newAction && newAction.options_parameters) {
      newAction.options_parameters[field] = String(value);
    }

    newAction.fields = newAction.options_parameters;

    this.props.dispatch({ type: 'CHANGE_CURRENT_ACTION', action: functions.cloneDeep(newAction) });
  };

  fillOptionsParametersList = async (optionsParametersShouldModify: Array<string>) => {
    const { currentConnect, options, currentAction } = this.props;
    const selectedOption = options && Array.isArray(options) && options.find((item: any) => item.id === currentAction.option_id);

    if (!optionsParametersShouldModify || optionsParametersShouldModify.length === 0) {
      return;
    }

    if (!selectedOption || !selectedOption.parameters || !Array.isArray(selectedOption.parameters.campos)) {
      return;
    }

    Promise.all(
      selectedOption.parameters.campos.map(async (item: any) => {
        if (!optionsParametersShouldModify.includes(item.nome)) {
          return;
        }

        if (item.campo_carregar) {
          const params = this.getOptionParametersQuery(item, selectedOption, currentAction);

          await this.dispatchNewOptionParam(currentConnect.autoresponder_id, currentConnect.id, item.nome, params);

          return;
        }

        await this.dispatchNewOptionParam(currentConnect.autoresponder_id, currentConnect.id, item.nome, undefined);

        return;
      })
    );
  };

  dispatchNewOptionParam = async (autoResponderId: number, connectId: number, itemName: string, params: any) => {
    const keys = itemName.split('_');
    const toSearch = `${keys[0]}_${keys[1]}`;

    let paramsString = undefined;

    if (params && typeof params === 'object') {
      paramsString = QueryString.stringify(params);
    }

    await this.props.dispatch(getActionFields(autoResponderId, connectId, toSearch, paramsString));
    const newOption = { field: itemName, value: this.props.actionFields };
    return this.props.dispatch({ type: 'ADD_NEW_OPTION_ACTION', newOption });
  };

  async componentDidUpdate(prevProps: any) {
    const { currentAction, currentConnect, options } = this.props;

    const currentConnectDidUpdate = prevProps.currentConnect !== currentConnect;
    const currentActionDidUpdate = currentAction !== prevProps.currentAction;

    if (currentConnect && currentConnectDidUpdate) {
      this.props.dispatch(listConnectOptions(currentConnect.autoresponder_id));
    }

    if (currentActionDidUpdate) {
      let newState = functions.cloneDeep(this.state);
      newState.validationErrors = run(currentAction, Validations);
      this.setState(newState);
    }

    const actionOptionsHasUpdated =
      prevProps.currentAction.options_parameters !== currentAction.options_parameters ||
      prevProps.currentAction.option_id !== currentAction.option_id;
    const shouldUpdateOptionsParametersList = currentAction && currentAction.options_parameters && currentConnect && actionOptionsHasUpdated;

    const optionsParametersShouldModify = this.getOptionsParametersShouldModify(currentAction, prevProps.currentAction, options);

    optionsParametersShouldModify.map((item: string) => {
      this.props.dispatch({ type: 'RESET_OPTION_ACTION', field: item });
      return false;
    });

    if (shouldUpdateOptionsParametersList) {
      this.fillOptionsParametersList(optionsParametersShouldModify);
    }
  }

  closeModal = () => {
    this.props.dispatch({ type: 'CLOSE_MODAL_EDIT_ACTION' });
    this.props.dispatch({ type: 'RESET_CURRENT_ACTION' });
  };

  saveNewAction = async () => {
    try {
      this.setState({ isSaving: true });
      let { currentConnect, currentAction } = this.props;
      await this.props.dispatch(updateAction(currentConnect.id, currentAction));
      this.closeModal();
      this.setState({ isSaving: false });
      toast.success('Ação salva com sucesso!');
      if (this.props.onSave) {
        this.props.onSave();
      }
    } catch (error) {
      this.setState({ isSaving: false });
      toast.error(error);
    }
  };

  componentWillMount() {
    this.props.dispatch(listTriggers());
  }

  getOptionsFieldName = (currentAction: any, itemName: string) => {
    if (itemName?.includes('_field_')) {
      itemName = itemName.replace('_field', '');
    }

    let value = currentAction.options_parameters[itemName];

    if (currentAction.fields) {
      value = currentAction.fields[itemName];
    }
    return [itemName, value];
  };

  render() {
    const { currentAction, currentConnect, classes, triggers, options, optionsAction } = this.props;
    const currentOptions = Array.isArray(options) ? options : [];
    const selectedOption = currentOptions.find((item: any) => item.id === currentAction.option_id);
    return (
      <Modal open={this.props.modal} onClose={this.props.handleClose}>
        <Paper
          elevation={10}
          style={{
            width: '640px',
            maxWidth: '100%',
            height: 'auto',
            top: '50%',
            left: '50%',
            position: 'absolute',
            transform: 'translate(-50%,-50%)',
            padding: '1.5rem',
            maxHeight: '90vh',
            overflow: 'auto',
          }}
        >
          <Typography variant='h6' style={{ color: '#192542' }}>
            Editar Ação
          </Typography>

          <Grid xs={12} spacing={2} container>
            {currentConnect && currentConnect.image && (
              <Grid xs={12} item>
                <List.Item>
                  <List.Left>
                    <div className={classes.imageTable} style={{ backgroundImage: `url(${currentConnect?.image})` }}></div>
                  </List.Left>
                  <List.Text
                    title={currentConnect?.name}
                    description={
                      <>
                        <p>{currentConnect?.description}</p>
                        <p>
                          <strong>{currentConnect?.parameters[0]?.label}</strong>
                        </p>
                        <Truncate count={50} final='...'>
                          {currentConnect?.parameters[0]?.value}
                        </Truncate>
                      </>
                    }
                  />
                </List.Item>
              </Grid>
            )}

            <Grid xs={12} md={3} item>
              <FormControlLabel
                control={
                  <Switch checked={currentAction.active} onChange={(e: any) => this.handleChange('active', e.target.checked)} value='active' />
                }
                label={currentAction.active ? 'Ativado' : 'Desativado'}
                labelPlacement='top'
              />
            </Grid>
            <Grid xs={12} md={9} item>
              <TextField
                fullWidth={true}
                label={'Título da ação'}
                InputProps={{ rows: 3, disableUnderline: true }}
                InputLabelProps={{ shrink: true }}
                placeholder='Digite o título da ação'
                value={currentAction.description}
                helperText={this.isValid('description') ? this.errorFor('description') : null}
                error={this.isValid('description')}
                onChange={(e: any) => this.handleChange('description', e.target.value)}
              />
            </Grid>
            <Grid xs={12} md={6} item>
              <TextField
                className={classes.input}
                id='trigger'
                select
                label='Se isso acontecer:'
                fullWidth
                value={currentAction.trigger_id}
                onChange={(e: any) => this.handleChange('trigger_id', e.target.value)}
                helperText={this.isValid('trigger_id') ? this.errorFor('trigger_id') : null}
                error={this.isValid('trigger_id')}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {triggers &&
                  Array.isArray(triggers) &&
                  triggers.map((item: any) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid xs={12} md={6} item>
              <TextField
                className={classes.input}
                id='option'
                select
                label='Faça isso:'
                fullWidth
                value={currentAction.option_id}
                onChange={(e: any) => this.handleChange('option_id', e.target.value)}
                helperText={this.isValid('option_id') ? this.errorFor('option_id') : null}
                error={this.isValid('option_id')}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!(options && Array.isArray(options))}
              >
                {currentOptions.map((option: any) => (
                  <MenuItem value={option.id} key={option.id}>
                    {option.title}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {currentAction.trigger_id &&
              currentAction.option_id &&
              currentAction.options_parameters &&
              selectedOption &&
              selectedOption.parameters &&
              Array.isArray(selectedOption.parameters.campos) &&
              selectedOption.parameters.campos.map((item: any) => {
                const [itemName, itemValue] = this.getOptionsFieldName(currentAction, item.nome);
                return item.tipo === 'list' || item.tipo === 'listdinamico' ? (
                  <Grid xs={12} key={`fieldAction-${item.nome}`} item>
                    <TextField
                      className={classes.input}
                      id={`option-${item.label}`}
                      select
                      label={item.label}
                      fullWidth
                      helperText={item.tooltip ? item.tooltip : ''}
                      value={String(currentAction.options_parameters[item.nome])}
                      onChange={(e: any) => this.handleChangeField(item.nome, e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={!currentAction.options_parameters || !Array.isArray(optionsAction[item.nome]) || optionsAction[item.nome].length <= 0}
                    >
                      {optionsAction[item.nome] &&
                        Array.isArray(optionsAction[item.nome]) &&
                        optionsAction[item.nome].length > 0 &&
                        optionsAction[item.nome].map((opt: any) => (
                          <MenuItem value={String(opt.id)} key={`key-${opt.id}`}>
                            {opt.name}
                          </MenuItem>
                        ))}
                    </TextField>
                    {currentConnect && currentConnect.autoresponder_id && currentConnect.autoresponder_id === constants.MAUTIC_AUTORESPONDER_ID && (
                      <FormHelperText>
                        * Caso a listagem não esteja carregando, limpe o cache do seu Mautic ou procure ajuda na&nbsp;
                        <a href='https://mautic.org/support' rel='noopener noreferrer' target='_blank'>
                          página de suporte do Mautic.
                        </a>
                      </FormHelperText>
                    )}
                  </Grid>
                ) : (
                  <Grid xs={12} item key={`fieldAction-${item.nome}`}>
                    <TextField
                      className={classes.input}
                      id='option'
                      label={item.label}
                      fullWidth
                      value={itemValue}
                      onChange={(e: any) => this.handleChangeField(itemName, e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    ></TextField>
                  </Grid>
                );
              })}

            <Grid item xs={12}>
              <Grid container justify='space-between'>
                <Button onClick={this.closeModal}>Cancelar</Button>
                <Button
                  variant='contained'
                  color='secondary'
                  disabled={this.state.validationErrors && this.state.validationErrors.length > 0}
                  onClick={this.saveNewAction}
                >
                  Salvar
                  {this.state.isSaving && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    currentAction: state.components.Connect.currentAction,
    modal: state.components.Connect.modalEditAction,
    currentConnect: state.components.Connect.currentConnect,
    triggers: state.orbita.Connect.listTriggers,
    options: state.orbita.Connect.listConnectOptions,
    actionFields: state.orbita.Connect.getActionFields,
    optionsAction: state.components.Connect.optionsAction,
    currentUser: state.orbita.User.user.user,
    newAction: false,
    step: false,
    fields: false,
  };
}

export default connect(mapStateToProps)(styles(EditAction));
